export default "__VITE_ASSET__CJWQntF9__"